import { SITE } from "@/constants/testIds";

export default function Reminder() {
  return (
    <section
      data-testid={SITE.reminder}
      className="relative bg-brand-cream py-20 md:py-28"
    >
      <div className="mx-auto max-w-4xl px-6 text-center md:px-10">
        <span className="text-xs uppercase tracking-[0.4em] text-brand-evergreen/60">
          A gentle reminder
        </span>

        <p
          className="mt-6 text-brand-evergreen"
          style={{
            fontFamily: '"Dancing Script", cursive',
            fontWeight: 600,
            fontSize: "clamp(2.25rem, 5vw, 3.75rem)",
            lineHeight: 1.15,
          }}
        >
          Practice makes improvement
        </p>

        <p className="mx-auto mt-8 max-w-2xl font-display text-xl italic leading-relaxed text-brand-charcoal/75 md:text-2xl">
          I encourage students to return for occasional tune-up lessons to keep
          their fundamentals — and their Spirit — strong.
        </p>

        <div className="mx-auto mt-10 flex w-32 items-center gap-3">
          <span className="h-px flex-1 bg-brand-evergreen/30" />
          <span className="h-1.5 w-1.5 rounded-full bg-brand-evergreen/40" />
          <span className="h-px flex-1 bg-brand-evergreen/30" />
        </div>
      </div>
    </section>
  );
}
